import React from "react";
import { Shield, Lock, Eye, Users, Bell, CreditCard, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Footer } from "./Footer";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const sections = [
    {
      id: 1,
      title: "Introduction",
      icon: <Shield className="w-5 h-5" />,
      content:
        "This Privacy Policy explains how AvanAval Team  collects, uses, shares, and protects the personal data of users accessing our matrimony services . By using AvanAval, you consent to this Privacy Policy.",
    },
    {
      id: 2,
      title: "Information We Collect",
      icon: <Eye className="w-5 h-5" />,
      subsections: [
        {
          title: "Personal Information:",
          items: [
            "Full Name",
            "Gender",
            "Date of Birth / Age",
            "Phone Number (OTP verification)",
            "Email Address",
            "Marital Status",
            "Religion & Caste",
            "Education and Employment details",
            "Location (city, state, country)",
          ],
        },
        {
          title: "Profile Information:",
          items: [
            "Photos uploaded by the user",
            "Partner preferences",
            "About Yourself field",
            "Family details",
          ],
        },
        {
          title: "Usage Data:",
          items: [
            "Profile views",
            "Chat and connection history",
            "Subscription details",
          ],
        },
        {
          title: "Device & Technical Data:",
          items: [
            "IP address",
            "Mobile device information",
            "Firebase device token (for notifications)",
          ],
        },
      ],
    },
    {
      id: 3,
      title: "How We Use Your Information",
      icon: <Users className="w-5 h-5" />,
      items: [
        "Create and manage your account",
        "Display your profile to other verified users",
        "Provide chat and connection features",
        "Improve matchmaking algorithms",
        "Process subscription payments",
        "Send notifications related to matches and messages",
        "Prevent fraud and unauthorized use",
      ],
    },
    {
      id: 4,
      title: "Consent",
      icon: <Lock className="w-5 h-5" />,
      content:
        "By creating an account or using AvanAval, you allow us to store and use your data for matrimony services, agree that other users can view your public profile details, and give permission for us to communicate through SMS, email, WhatsApp, or notifications. You can withdraw consent anytime by deleting your account.",
    },
    {
      id: 5,
      title: "Sharing Information with Third Parties",
      icon: <Users className="w-5 h-5" />,
      content:
        "We do not sell user data. We may share information only with trusted third-party service providers: Firebase for OTP verification & notifications and Razorpay for Secure payment processing . These third parties follow strong data protection standards.",
    },
    {
      id: 6,
      title: "Data Security",
      icon: <Lock className="w-5 h-5" />,
      content:
        "We use industry-standard measures such as secure servers, encryption for sensitive data, and access control for internal staff. However, we cannot guarantee 100% security from unauthorized access.",
    },
    {
      id: 7,
      title: "User Rights",
      icon: <Eye className="w-5 h-5" />,
      items: [
        "View their data",
        "Edit or update profile information",
        "Delete photos or entire account",
        "Withdraw consent",
        "Report misuse",
      ],
      note: "When you delete your account, we remove your data from our active systems within a reasonable time.",
    },
    {
      id: 8,
      title: "Children's Privacy",
      icon: <Shield className="w-5 h-5" />,
      content:
        "Users below 18 years are not eligible to use the Platform. We do not intentionally collect data of minors.",
    },
    {
      id: 9,
      title: "Cookies & Tracking",
      icon: <Bell className="w-5 h-5" />,
      content:
        "We may use cookies, device identifiers, and analytics tools. These help improve performance and user experience.",
    },
    {
      id: 10,
      title: "Changes to Policy",
      icon: <Shield className="w-5 h-5" />,
      content:
        "We may update this Privacy Policy occasionally. The latest version will always be displayed on our Platform. Continued use after changes means acceptance of the updated policy.",
    },
    {
      id: 11,
      title: "Legal Jurisdiction",
      icon: <Lock className="w-5 h-5" />,
      content:
        "This Privacy Policy is governed by the laws of India. Any dispute will be handled exclusively in Courts in India.",
    },
    {
      id: 12,
      title: "Contact Us",
      icon: <CreditCard className="w-5 h-5" />,
      content: "For questions or concerns: 📧 Email: support@avanaval.com",
    },
  ];

  return (
    <>
      <div className="bg-white shadow-sm border-b border-border">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="w-full flex justify-between items-center h-16">
            {/* Back Button on Left End */}
            <button
              onClick={() => {
                navigate('/');
              }}
              className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="text-lg font-medium">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
        //   minHeight: "100vh",
          backgroundColor: "#fef2f2",
        //   padding: "2rem 0 4rem",
        marginTop:"5vh"
        }}
      >
        {/* Header Section */}
        <div
          style={{
            width: "90%",
            // maxWidth: "800px",
            margin: "auto",
            marginBottom: "10vh",
            backgroundColor: "white",
            padding: "3rem",
            borderRadius: "16px",
            boxShadow: "0 8px 30px rgba(0, 0, 0, 0.08)",
            marginTop: "4rem",
          }}
        >
          {/* Main Header */}
          <div
            style={{
              textAlign: "center",
              marginBottom: "3rem",
              paddingBottom: "2rem",
              borderBottom: "2px solid #fee2e2",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "12px",
                marginBottom: "1rem",
              }}
            >
              <div
                style={{
                  padding: "12px",
                  borderRadius: "12px",
                  background:
                    "linear-gradient(135deg, #e74343ff 0%, #e34c90ff 100%)",
                  color: "white",
                }}
              >
                <Shield size={28} />
              </div>
              <h1
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "700",
                  background:
                    "linear-gradient(135deg, #e74343ff 0%, #e34c90ff 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  margin: 0,
                }}
              >
                Privacy Policy
              </h1>
            </div>

            <p
              style={{
                fontSize: "1rem",
                color: "#666",
                maxWidth: "600px",
                margin: "0 auto",
                lineHeight: "1.6",
              }}
            >
              Effective Date:{" "}
              {new Date().toLocaleDateString("en-IN", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </p>
          </div>

          {/* Important Note */}
          <div
            style={{
              backgroundColor: "#dbeafe",
              borderLeft: "4px solid #3b82f6",
              padding: "1.25rem",
              borderRadius: "8px",
              marginBottom: "2.5rem",
              display: "flex",
              gap: "12px",
              alignItems: "flex-start",
            }}
          >
            <Lock size={20} color="#1e40af" />
            <div>
              <p
                style={{
                  fontSize: "0.95rem",
                  color: "#1e40af",
                  margin: "0",
                  fontWeight: "500",
                  lineHeight: "1.6",
                }}
              >
                We are committed to protecting your privacy. Your data is
                secured with industry-standard encryption and access controls.
              </p>
            </div>
          </div>

          {/* Content Sections */}
          <div>
            {sections.map((section) => (
              <div
                key={section.id}
                style={{
                  padding: "1.75rem 0",
                  borderBottom:
                    section.id === sections.length
                      ? "none"
                      : "1px solid #f0f0f0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "1rem",
                  }}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "#fee2e2",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#dc2626",
                    }}
                  >
                    {section.icon}
                  </div>
                  <h2
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "600",
                      color: "#1f2937",
                      margin: 0,
                    }}
                  >
                    {section.id}. {section.title}
                  </h2>
                </div>

                {/* Content */}
                {section.content && (
                  <p
                    style={{
                      fontSize: "1rem",
                      lineHeight: "1.7",
                      color: "#4b5563",
                      marginBottom:
                        section.items || section.subsections ? "1rem" : "0",
                      marginLeft: "52px",
                    }}
                  >
                    {section.content}
                  </p>
                )}

                {/* Subsections */}
                {section.subsections && (
                  <div style={{ marginLeft: "52px" }}>
                    {section.subsections.map((subsection, idx) => (
                      <div key={idx} style={{ marginBottom: "1rem" }}>
                        <p
                          style={{
                            fontSize: "1rem",
                            fontWeight: "600",
                            color: "#374151",
                            marginBottom: "0.5rem",
                          }}
                        >
                          {subsection.title}
                        </p>
                        <ul
                          style={{
                            fontSize: "1rem",
                            lineHeight: "1.7",
                            color: "#4b5563",
                            paddingLeft: "1.5rem",
                            margin: "0",
                          }}
                        >
                          {subsection.items.map((item, itemIdx) => (
                            <li
                              key={itemIdx}
                              style={{ marginBottom: "0.25rem" }}
                            >
                              {item}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}

                {/* Items List */}
                {section.items && !section.subsections && (
                  <ul
                    style={{
                      fontSize: "1rem",
                      lineHeight: "1.7",
                      color: "#4b5563",
                      paddingLeft: "3rem",
                      margin: "0",
                    }}
                  >
                    {section.items.map((item, idx) => (
                      <li
                        key={idx}
                        style={{
                          marginBottom: "0.5rem",
                          position: "relative",
                        }}
                      >
                        <span
                          style={{
                            position: "absolute",
                            left: "-1rem",
                            color: "#dc2626",
                            fontWeight: "bold",
                          }}
                        >
                          •
                        </span>
                        {item}
                      </li>
                    ))}
                  </ul>
                )}

                {/* Note */}
                {section.note && (
                  <div
                    style={{
                      backgroundColor: "#f8fafc",
                      borderLeft: "3px solid #94a3b8",
                      padding: "1rem",
                      borderRadius: "6px",
                      marginTop: "1rem",
                      marginLeft: "52px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "0.95rem",
                        lineHeight: "1.6",
                        color: "#475569",
                        margin: "0",
                        fontStyle: "italic",
                      }}
                    >
                      {section.note}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <Footer/>
      </div>
    </>
  );
};

export default PrivacyPolicy;
